import './App.scss';

import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
// @ts-ignore
import CookieConsent from 'react-cookie-consent';

import Footer from './components/Footer';
import Header from './components/Header';
import { languages } from './config';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';
import Cart from './pages/Cart';
import Contact from './pages/Contact';
import Favorite from './pages/Favorite';
import ForgottenPw from './pages/ForgottenPw';
import RecoverPw from './pages/RecoverPw';
import Home from './pages/Home';
import Login from './pages/Login';
import PaymentAndShipping from './pages/PaymentAndShipping';
import PersonalData from './pages/PersonalData';
import OrderBasket from './pages/OrderBasket';
import OrderDetail from './pages/OrderDetail';
import OrderFinished from './pages/OrderFinished';
import OrderList from './pages/OrderList';
import Detail from './pages/ProductDetail';
import Products from './pages/Products';
import Registration from './pages/Registration';
import UserData from './pages/UserData';
import GroupSection from './pages/GroupSection';
import UserPassword from './pages/UserPassword';
import * as StaticDocuments from './pages/TextPage';
import NotFound from './pages/NotFound';
import GetCountryQuery from './components/Query/Countries/Country';
import CountryService from './services/CountryService';
import Link from './components/Link';
import ForceLogin from './pages/ForceLogin';
import GetUserInfoQuery from './components/Query/User/UserInfo';
import AuthService from './services/AuthService';
import PriceListPage from './pages/PriceList';
import { detectCountryByGeoLocation } from './helpers/country/detectCountryByGeoLocation';
import ExternalCart from './pages/ExternalCart';
import ExportPriceList from './pages/ExportPriceList';

import AvailabilityWatchDogButton from './modules/AvailabilityWatchFormButton/AvailabilityWatchFormButton';
import ErrorPage from './pages/ErrorPage';
import GetCountryByCurrencyQuery from './components/Query/Countries/CountryByCurrency';
import GetPrimaryCurrencyQuery from './components/Query/Currencies/PrimaryCurrency';
import Helmet from 'react-helmet';
import { canUseDOM } from './utils';
import GoogleTagManagerService from './services/GoogleTagManagerService';
import { renderWebsite as renderWebsiteLDJSON } from './helpers/ld_json';
import CartService from './services/CartService';

// Forces switching to default currency, when currency param is not present in URL
const FORCE_DEFAULT_CURRENCY: boolean = false;
const USE_EXTERNAL_COOKIE_CONSENT: boolean = true;

interface IAppProps extends RouteComponentProps<{ language?: string }> {
  navData?: any;
}

interface IAppState {
  mounted: boolean;
  isLoaded: boolean;
  currency: any;
  countryCode: string;
  geolocationCountryCode?: string;
  watchDogProductForm?: {
    product: GQL.IProduct,
    variant: GQL.IProductVariant,
  };
  flagCleaned?: true;
}

class App extends React.Component<IAppProps> {

  public state: IAppState;

  constructor(props: IAppProps) {
    super(props);

    this.state = {
      mounted: false,
      isLoaded: false,
      currency: { value: '', id: '' },
      countryCode: '',
    };

    this.setMounted = this.setMounted.bind(this);
    this.renderComponents = this.renderComponents.bind(this);
    this.setCurrentProductAvailabityWatchdogForm = this.setCurrentProductAvailabityWatchdogForm.bind(this);
  }

  public setMounted() {
    this.setState({ mounted: true });

    if (window && window.addEventListener) {
      window.removeEventListener('load', this.setMounted);
    }
  }

  public onLoad() {
    if (!this.state.isLoaded) {
      this.setState({ isLoaded: true });
    }
  }

  public componentDidMount() {
    const { location: { pathname, search }, history: { push } } = this.props;
    const countryObj = CountryService.GetInstance().country;
    const url = this.props.location.pathname.split('/');

    const params = new URLSearchParams(search);
    const currentCurrency = params.get('currency') || null;

    let code = null;
    if (url.length >= 1 && url[1] !== '' && languages.indexOf(url[1]) >= 0) {
      code = url[1];
      this.setState({ countryCode: code });
    } else if (!!countryObj) {
      // Country code urls are not used anymore
      // return push(`/${countryObj.code}${pathname}${search}`);
      // so just fill 'code' from the country
      // if (!currentCurrency || (countryObj.currency && (currentCurrency === countryObj.currency.value))) {
      if (countryObj.currency && (currentCurrency === countryObj.currency.value)) {
        code = countryObj.code;
      }
    }

    let useGeolocation = true;
    if (currentCurrency) {
      useGeolocation = false;
    }

    if (useGeolocation && (!code || languages.indexOf(code) === -1)) {
      detectCountryByGeoLocation()
        .then((result) => {
          // Country code urls are not used anymore
          // return push(`/${result}${pathname}${search}`);
          // so just set 'countryCode' from the result
          this.setState({
            countryCode: result,
            geolocationCountryCode: result,
          });
        });
    }

    if (window && window.addEventListener) {
      window.addEventListener('load', this.setMounted);
    }
  }

  public render() {
    const currentCart = CartService.GetInstance();
    const isCartSetup = currentCart.invoiceCountryByCustomer;
    if (isCartSetup) {
      CountryService.GetInstance().setCountry({ ...currentCart.invoiceCountryByCustomer });
    }

    const { countryCode, country: currentCountry } = CountryService.GetInstance();

    const { isLoaded } = this.state;

    let cart = false;
    if (typeof location !== 'undefined' && countryCode) {
      if (location.pathname === `/${countryCode}/cart` || location.pathname === `/${countryCode}/order`) {
        cart = true;
      }
    }

    const url = this.props.location.pathname.split('/');
    // Country code urls are not used anymore
    // const code = (url.length > 1 && url[1] !== '' && languages.indexOf(url[1]) >= 0 ? url[1] : null);
    // so just fill 'code' from the countryCode
    let code = countryCode;
    // kvůli SSR, protože si z nějakého důvodu pamatuje zemi z předcházejícího běhu
    if (('undefined' !== typeof (global as any).SSR) && (true === (global as any).SSR)) {
      (code as any) = null;
    }

    const codeInUrl = (url.length > 1 && url[1] !== '' && languages.indexOf(url[1]) >= 0 ? url[1] : null);

    return (
      <div className="App">
        {!codeInUrl
          && <Helmet>
            <link rel="canonical" href={`${process.env.REACT_APP_SHOP_URL_PROD}${this.props.location.pathname}`} />
            {renderWebsiteLDJSON(this.props.location.pathname)}
          </Helmet>
          || ''}

        <GetPrimaryCurrencyQuery>{({ primaryCurrency }: any) => {
          if ((primaryCurrency.loading) || ('undefined' === typeof primaryCurrency.primaryCurrency)) {
            return null;
          }
          const primaryCurrencyCode = primaryCurrency.primaryCurrency && primaryCurrency.primaryCurrency.value || null;
          if (primaryCurrencyCode) {
            CountryService.GetInstance().setPrimaryCurrencyCode(primaryCurrencyCode);
          }

          const params = new URLSearchParams(this.props.location.search);
          const currentCurrency = params.get('currency') || null;
          return (
            <>
              <GetCountryByCurrencyQuery
                currencyCode={currentCurrency}
              >
                {({ country: currencyCountry }: any) => {
                  if (currencyCountry.loading) {
                    return null;
                  }
                  const checkCurrency = currentCurrency || primaryCurrencyCode;
                  if (
                    !currentCountry
                    || (
                      // v SSR vždy vynutit default currency
                      (FORCE_DEFAULT_CURRENCY || (('undefined' !== typeof (global as any).SSR) && (true === (global as any).SSR))) && currentCountry.currency
                      && (currentCountry.currency.value !== checkCurrency)
                    )
                    || (
                      currentCurrency && currentCountry.currency
                      && (currentCountry.currency.value !== checkCurrency)
                    )
                  ) {
                    if (currencyCountry.countryByCurrency && currencyCountry.countryByCurrency.code) {
                      code = currencyCountry.countryByCurrency.code;
                    }
                  }
                  // kvůli SSR, protože si z nějakého důvodu pamatuje zemi z předcházejícího běhu
                  if (!code && currencyCountry.countryByCurrency && currencyCountry.countryByCurrency.code) {
                    code = currencyCountry.countryByCurrency.code;
                  }

                  const redirect = CountryService.GetInstance().getRedirectCountryCode;
                  if (redirect) {
                    code = redirect;
                  }
                  if (this.state.geolocationCountryCode) {
                    code = this.state.geolocationCountryCode;
                  }

                  return (
                    <GetCountryQuery code={code}>
                      {({ country }: any) => {
                        if (!country.loading && country.country) {
                          if (!isCartSetup) {
                            CountryService.GetInstance().setCountry(country.country, isLoaded);
                            CountryService.GetInstance().setRedirectCountryCode(null);
                          }
                          
                          // if temporary country is set, reset it
                          if (('' !== this.state.countryCode) || this.state.geolocationCountryCode) {
                            this.setState({
                              countryCode: '',
                              geolocationCountryCode: null,
                            });
                          }

                          // check current currency and redirect to correct one
                          if (currentCurrency && country.country.currency && (country.country.currency.value !== currentCurrency)) {
                            return (
                              <Route
                                render={(routeProps) => {
                                  if (routeProps.staticContext) {
                                    routeProps.staticContext.statusCode = 301;
                                  }
                                  params.set('currency', country.country.currency.value);
                                  const newSearch = params.toString();
                                  return <Redirect to={`${this.props.location.pathname}${newSearch.length > 0 ? `?${newSearch}` : ''}`} />;
                                }}
                              />
                            );
                          } else if (!currentCurrency && primaryCurrencyCode && country.country.currency && (country.country.currency.value !== primaryCurrencyCode)) {
                            return (
                              <Route
                                render={(routeProps) => {
                                  if (routeProps.staticContext) {
                                    routeProps.staticContext.statusCode = 301;
                                  }
                                  params.set('currency', CountryService.GetInstance().currencyCodePageParam);
                                  const newSearch = params.toString();
                                  return <Redirect to={`${this.props.location.pathname}${newSearch.length > 0 ? `?${newSearch}` : ''}`} />;
                                }}
                              />
                            );
                          } else if (currentCurrency && primaryCurrencyCode && country.country.currency && (country.country.currency.value === primaryCurrencyCode)) {
                            return (
                              <Route
                                render={(routeProps) => {
                                  if (routeProps.staticContext) {
                                    routeProps.staticContext.statusCode = 301;
                                  }
                                  params.delete('currency');
                                  const newSearch = params.toString();
                                  return <Redirect to={`${this.props.location.pathname}${newSearch.length > 0 ? `?${newSearch}` : ''}`} />;
                                }}
                              />
                            );
                          }
                        }
                        return null;
                      }}
                    </GetCountryQuery>
                  );
                }}
              </GetCountryByCurrencyQuery>

              {AuthService.GetInstance().notDetected &&
                <GetUserInfoQuery>
                  {({ userInfo }: any) => {

                    if (userInfo && !userInfo.loading) {
                      if (userInfo.userInfo) {
                        AuthService.GetInstance().setCustomer(userInfo.userInfo);
                      } else {
                        AuthService.GetInstance().setCustomer(null);
                      }
                    }

                    return null;
                  }}
                </GetUserInfoQuery>}

              {(() => {
                // pokud v DOMu existuje SSRem vyrendrovaná vlajka, je nutné ji smazat,
                // jinak to způsobuje problémy - při prvním načtení stránky se sice země nastaví na zemi uloženou
                // v localStorage, ale správná vlajka se nenastaví
                if ((!this.state.flagCleaned) && canUseDOM() && ('getElementById' in document)) {
                  const el = (document as any).getElementById('country_flag');
                  if (el) {
                    el.remove();
                  }
                  // provedení smazání si poznačíme, aby smazání vlajky proběhlo pouze jednou
                  this.setState({ flagCleaned: true });
                }
              })()}

              <Switch>
                <Route
                  exact={false}
                  path={`/:language(${languages.join('|')})`}
                  // component={this.renderComponents}
                  // render={(props) => <this.NonCountryCodeRedirect {...props}/>}
                  // Temporary solution till all routes are redirected
                  render={() => this.renderComponents(true)}
                />
                <Route
                  exact={false}
                  path={'/'}
                  component={this.renderComponents}
                />

                {code !== countryCode &&
                  <Redirect to={`/${code}`} />}
              </Switch>
            </>
          );
        }}</GetPrimaryCurrencyQuery>

        {this.state.watchDogProductForm && this.state.watchDogProductForm.product
          && this.state.watchDogProductForm.variant && AvailabilityWatchDogButton.renderModal
          && AvailabilityWatchDogButton.renderModal(
            true,
            this.state.watchDogProductForm.product,
            this.state.watchDogProductForm.variant,
            this.setCurrentProductAvailabityWatchdogForm,
            'global-modal'
          )
          || ''}

        {!USE_EXTERNAL_COOKIE_CONSENT && <CookieConsent
          buttonText={'Got it!'}
          style={{
            backgroundColor: 'rgb(239, 239, 239)',
            color: 'rgb(52, 52, 52)',
            fontWeight: 100,
            fontSize: '16px'
          }}
          buttonStyle={{
            fontWeight: 100,
            fontSize: '16px',
            backgroundColor: 'rgb(229, 0, 0)',
            color: 'white'
          }}
        >
          <img src="https://www.divesoft.eu/assets/divesoft/images/cookie.svg" alt="cookies" style={{ maxHeight: '19px', maxWidth: '19px' }} />
          This website uses cookies to ensure you get the best experience on our website.
          {` `}<Link to={'https://cookiesandyou.com/'} target="_blank">Learn more</Link>
        </CookieConsent> || ''}
      </div>
    );
  }

  private NonCountryCodeRedirect = (props: RouteComponentProps) => {
    const originalURL = props.history.location.pathname;
    const url = originalURL.split('/');
    if ((url.length > 1) && url[0] === '') {
      const initial = url.shift();
      const countryCode = url.shift();
      url.unshift(initial || '');
      if (countryCode) {
        CountryService.GetInstance().setRedirectCountryCode(countryCode);
      }
    }
    const redirectUrl = url.join('/') || '/'; // slash for Homepage, otherwise only ?currency is added
    if (originalURL !== redirectUrl) {
      const currencyCode = CountryService.GetInstance().currencyCode;
      const params = new URLSearchParams(props.history.location.search);
      params.set('currency', currencyCode);
      // currency se přidává pouze na klientovi, ale ne v SSR
      const extendedURL = `${redirectUrl}${(currencyCode && !(global as any).SSR)
        ? `?${params.toString()}`
        : props.history.location.search.length > 0
          ? props.history.location.search
          : ''}`;
      if (props.staticContext) {
        props.staticContext.statusCode = 301;
      }
      return <Redirect to={extendedURL} />;
    }
    return <ErrorPage title="Invalid redirect" />;
  }

  private renderComponents(redirect?: boolean) {
    GoogleTagManagerService.virtualPageView();

    return (
      <>
        <Header
          navData={this.props.navData}
          cart={true}
        />
        <Switch>
          <Route exact={true} path="/" component={Home} />

          <Route
            exact={true}
            path="/:language/external-cart/:items?"
            component={ExternalCart}
          />

          <Route
            exact={true}
            path="/:language/force-login/:token"
            component={ForceLogin}
          />
          <Route
            exact={true}
            path="/:language/about"
            component={StaticDocuments.About}
          />
          <Route
            exact={true}
            path="/:language/cooperation"
            component={StaticDocuments.Cooperation}
          />
          <Route
            exact={true}
            path="/:language/conditions"
            component={StaticDocuments.TermsConditions}
          />
          <Route
            exact={true}
            path="/:language/delivery"
            component={StaticDocuments.Delivery}
          />
          {/* <Route
            exact={true}
            path="/:language/personal-data"
            component={StaticDocuments.PersonalData}
          /> */}
          <Route
            exact={true}
            path="/:language/loyalty"
            component={StaticDocuments.Loyalty}
          />
          <Route
            exact={true}
            path="/:language/return-policy"
            component={StaticDocuments.ReturnPolicy}
          />
          <Route
            exact={true}
            path="/:language/claim"
            component={StaticDocuments.Claim}
          />
          <Route
            exact={true}
            path="/:language/contact"
            component={StaticDocuments.ContactEshop}
          />
          <Route
            exact={true}
            path="/:language/tracking"
            component={StaticDocuments.Tracking}
          />
          <Route
            exact={true}
            path="/:language/eshop"
            component={StaticDocuments.Basket}
          />
          <Route
            exact={true}
            path="/:language/contacts"
            component={StaticDocuments.Contacts}
          />
          <Route
            exact={true}
            path="/:language/before-purchase"
            component={StaticDocuments.BeforePurchase}
          />
          <Route
            exact={true}
            path="/:language/after-purchase"
            component={StaticDocuments.AfterPurchase}
          />

          {/* redirect from country url to non-country url */}
          <Route
            exact={true}
            path={`/:language(${languages.join('|')})/products`}
            render={(props) => <this.NonCountryCodeRedirect {...props} />}
          />

          <Route
            exact={true}
            path="/products"
            // component={Products} // render is needed to pass the prop
            render={(props) => <Products setCurrentProductAvailabityWatchdogForm={this.setCurrentProductAvailabityWatchdogForm} {...props} />}
          />
          <Route
            exact={true}
            path="/products/:categoryChain"
            // component={Products} // render is needed to pass the prop
            render={(props) => <Products setCurrentProductAvailabityWatchdogForm={this.setCurrentProductAvailabityWatchdogForm} {...props} />}
          />

          <Route exact={true} path="/payment-and-shipping" component={PaymentAndShipping} />
          <Route exact={true} path="/personal-data" component={PersonalData} />
          {/* This route is called externally, so keep both the lanuage version and non-language version to prevent possible problems */}
          <Route exact={true} path="/cart/:voucher?/:sku?" component={Cart} />
          <Route exact={true} path="/:language/cart/:voucher?/:sku?" component={Cart} />

          <Route
            exact={true}
            path="/:language/order"
            component={OrderBasket}
          />

          <Route
            exact={true}
            path="/order-finished"
            component={OrderFinished}
          />
          {/* This route is called externally, so keep both the lanuage version and non-language version to prevent possible problems */}
          <Route
            exact={true}
            path="/order-finished/:orderNumber/:orderId?/:nextData?"
            component={OrderFinished}
          />
          <Route
            exact={true}
            path="/:language/order-finished/:orderNumber/:orderId?/:nextData?"
            component={OrderFinished}
          />
          <Route
            exact={true}
            path="/:language/password-reset/:token"
            component={RecoverPw}
          />
          <Route
            exact={true}
            path="/:language/register"
            component={Registration}
          />
          <Route exact={true} path="/:language/login" component={Login} />
          <Route
            exact={true}
            path="/:language/forgottenPw"
            component={ForgottenPw}
          />
          <Route
            exact={true}
            path="/:language/recoverPw"
            component={RecoverPw}
          />

          <Route
            exact={true}
            path="/:language/favorite"
            component={Favorite}
          />
          <Route
            exact={true}
            path="/:language/contact-us"
            component={Contact}
          />
          <Route
            exact={true}
            path="/:language/blog"
            component={Blog}
          />
          <Route
            exact={true}
            path="/:language/blog/:articleId"
            component={BlogArticle}
          />
          <Route
            exact={true}
            path="/user/orders"
            component={OrderList}
          />
          <Route
            exact={true}
            path="/user/orders/detail/:orderNumber"
            component={OrderDetail}
          />
          <Route
            exact={true}
            path="/user/data"
            component={UserData}
          />
          <Route
            exact={true}
            path="/user/group/:groupId"
            component={GroupSection}
          />
          <Route
            exact={true}
            path="/:language/user/export-pricelist/"
            component={ExportPriceList}
          />
          <Route
            exact={true}
            path="/user/password/"
            component={UserPassword}
          />
          <Route
            exact={true}
            path="/:productSlug/:ean"
            // component={Detail} // render is needed to pass the prop
            render={(props) => <Detail setCurrentProductAvailabityWatchdogForm={this.setCurrentProductAvailabityWatchdogForm} {...props} />}
          />
          {/* redirect from country url to non-country url */}
          <Route
            exact={true}
            path={`/:language(${languages.join('|')})/:productSlug/:ean`}
            render={(props) => <this.NonCountryCodeRedirect {...props} />}
          />
          <Route
            exact={true}
            path="/:categorySlug/:productSlug/:ean"
            // component={Detail} // render is needed to pass the prop
            render={(props) => <Detail setCurrentProductAvailabityWatchdogForm={this.setCurrentProductAvailabityWatchdogForm} {...props} />}
          />
          <Route
            exact={true}
            path="/:language/pricelist"
            component={PriceListPage}
          />

          <Route
            exact={true}
            // component={NotFound}
            // Temporary soultion till all pages are redirected
            render={(props) => redirect ? <this.NonCountryCodeRedirect {...props} /> : <NotFound />}
          />
        </Switch>
        <Footer
          navData={this.props.navData}
        />
      </>
    );
  }

  public setCurrentProductAvailabityWatchdogForm(product?: GQL.IProduct, variant?: GQL.IProductVariant) {
    if (product && product.id && variant && variant.id) {
      this.setState({
        watchDogProductForm: {
          product,
          variant,
        }
      });
    } else {
      this.setState({ watchDogProductForm: undefined });
    }
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.tsx